import React from "react";
import "./HrDataAssistant.css";
import * as myConstClass from "./../constant.js";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://hrm.workzonemalaysia.com/index.php";

const EXAMPLE_QUESTIONS = [
  "How many employees are on leave today?",
  "Show me pending leave requests",
  "Who checked in late this week?",
  "How many employees do we have?",
];

class HrDataAssistant extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      input: "",
      isLoading: false,
      messages: [
        {
          from: "bot",
          text: "Hi! I can answer questions about your HR data — leave, attendance, employees. Try asking something like \"how many employees are on leave today?\"",
        },
      ],
    };

    this.messagesEndRef = React.createRef();
  }

  componentDidUpdate() {
    if (this.messagesEndRef.current) {
      setTimeout(() => {
        this.messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
      }, 0);
    }
  }

  toggleOpen = () => {
    this.setState((state) => ({ isOpen: !state.isOpen }));
  };

  setInput = (event) => {
    this.setState({ input: event.target.value });
  };

  askAI = async (question) => {
    this.setState((state) => ({
      isLoading: true,
      messages: [...state.messages, { from: "user", text: question }],
      input: "",
    }));

    try {
      const res = await fetch(
                  myConstClass.BASE_URL +`ai_assistant/ask`, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: `question=${encodeURIComponent(question)}`,
        credentials: "include", // sends session cookie so org_id is available server-side
      });

      let data;
      try {
        data = await res.json();
      } catch (parseErr) {
        data = null;
      }

      const text =
        (data && (data.error || data.answer)) ||
        "Sorry, I couldn't get an answer for that. Please try rephrasing your question.";

      this.setState((state) => ({
        isLoading: false,
        messages: [...state.messages, { from: "bot", text }],
      }));
    } catch (err) {
      console.error("HR data assistant error:", err);
      this.setState((state) => ({
        isLoading: false,
        messages: [
          ...state.messages,
          { from: "bot", text: "Something went wrong reaching the AI assistant. Please try again." },
        ],
      }));
    }
  };

  submitMessage = () => {
    const question = this.state.input.trim();
    if (!question || this.state.isLoading) return;
    this.askAI(question);
  };

  renderMessage(message, index) {
    if (!message || !message.text) return null;
    return (
      <div key={index} className={`hr-ai-message hr-ai-message-${message.from}`}>
        <div>{message.text}</div>
      </div>
    );
  }

  render() {
    const { isOpen, input, isLoading, messages } = this.state;

    return (
      <div className="hr-ai-assistant">
        {isOpen && (
          <div className="hr-ai-panel">
            <div className="hr-ai-header">
              <div>
                <div className="hr-ai-title">HR Data Assistant</div>
                <div className="hr-ai-subtitle">Ask questions about your HR data</div>
              </div>
              <button type="button" className="hr-ai-close" onClick={this.toggleOpen}>
                ✕
              </button>
            </div>

            <div className="hr-ai-messages">
              {messages.map((message, index) => this.renderMessage(message, index))}
              {isLoading && (
                <div className="hr-ai-message hr-ai-message-bot">
                  <div>Thinking...</div>
                </div>
              )}
              <div ref={this.messagesEndRef} />
            </div>

            <div className="hr-ai-suggestions">
              {EXAMPLE_QUESTIONS.map((question) => (
                <button
                  type="button"
                  key={question}
                  onClick={() => this.askAI(question)}
                  disabled={isLoading}
                >
                  {question}
                </button>
              ))}
            </div>

            <div className="hr-ai-input-row">
              <input
                value={input}
                onChange={this.setInput}
                onKeyDown={(event) => {
                  if (event.key === "Enter") this.submitMessage();
                }}
                placeholder="Ask about leave, attendance, employees..."
                disabled={isLoading}
              />
              <button
                type="button"
                onClick={this.submitMessage}
                disabled={!input.trim() || isLoading}
              >
                Send
              </button>
            </div>
          </div>
        )}

        <button type="button" className="hr-ai-launcher" onClick={this.toggleOpen}>
          HR AI
        </button>
      </div>
    );
  }
}

export default HrDataAssistant;
